/// <amd-module name="SuiteCommerce.Blog.TaxonomyNavigation.Taxonomy.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.TaxonomyNavigation.Taxonomy.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TaxonomyNavigationTaxonomyModel = void 0;
    var TaxonomyNavigationTaxonomyModel = /** @class */ (function (_super) {
        __extends(TaxonomyNavigationTaxonomyModel, _super);
        function TaxonomyNavigationTaxonomyModel(options) {
            return _super.call(this, options) || this;
        }
        Object.defineProperty(TaxonomyNavigationTaxonomyModel.prototype, "name", {
            get: function () {
                return this.get('name');
            },
            set: function (name) {
                this.set('name', name);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TaxonomyNavigationTaxonomyModel.prototype, "urlComponent", {
            get: function () {
                return this.get('urlComponent');
            },
            set: function (urlFragment) {
                this.set('urlComponent', urlFragment);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TaxonomyNavigationTaxonomyModel.prototype, "isHighlighted", {
            get: function () {
                return this.get('isHighlighted');
            },
            set: function (isHighlighted) {
                this.set('isHighlighted', isHighlighted);
            },
            enumerable: false,
            configurable: true
        });
        return TaxonomyNavigationTaxonomyModel;
    }(Backbone_1.Model));
    exports.TaxonomyNavigationTaxonomyModel = TaxonomyNavigationTaxonomyModel;
});
